import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {Subject} from 'rxjs';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {HttpClient} from '@angular/common/http';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';
import {Api} from '@shared/constants/common-field.constants';
import {GridValueChangeEvent} from '@shared/models/common.models';
import {AuthApiService} from '@core/services/auth-api.service';
import {PlatformSidebarService} from '@shared/components/platform-sidebar/store/platform-sidebar.service';
import {PlatformSidebarRoutesForNavigation} from '@shared/components/platform-sidebar/store/platform-sideber-routes-for-navigration.service';
import {Dynamic_Grid_Data_Request_Parameters} from '@shared/store/actions/virtual-grid.actions';
import {ParticleCacheService} from '@core/services/particle-cache.service';

@Injectable({
  providedIn: 'root',
})
export class PlatformToolExpertServicesHandler implements IPlatformToolHandler {
  constructor(private httpClient: HttpClient,
              private commandService: CommandService,
              private router: Router,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private platformSidebarService: PlatformSidebarService,
              private platformSidebarRoutesForNavigation: PlatformSidebarRoutesForNavigation,
              private snackBarService: SnackBarService,
              private authApiService: AuthApiService,
              private particleCacheService: ParticleCacheService
  ) {
    this.invalidateSubject = new InvalidateSubject();
  }
  magicLinkModel: MagicLinkModel;
  ngUnsubscribe = new Subject<void>();
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter<any>();
  invalidateSubject: InvalidateSubject;
  selectedTab: TabModel;


  executeCommand(command: PlatformCommand) {
    switch (command.name) {
      case 'ArchiveCompanyCommand':
        this.confirmationDialog(command, 'Archive', 'Are you sure to archive this company?');
        break;
      case 'UnArchiveCompanyCommand':
        this.confirmationDialog(command, 'Unarchive', 'Are you sure to unarchive this company?');
        break;
      case 'ArchiveSolutionCommand':
        this.confirmationDialog(command, 'Archive', 'Are you sure to archive this company?');
        break;
      case 'UnArchiveSolutionCommand':
        this.confirmationDialog(command, 'Unarchive', 'Are you sure to unarchive this company?');
        break;
      default:
        this.executeCommandApi(command);
    }
  }

  private executeCommandApi(command: PlatformCommand) {
    console.log('[Executing PlatformCommand] -> ', command.name);
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(res => {
          console.log('Command Response', res);
          this.fuseSplashScreenService.hide();
          if (res.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(res.fieldValues['RedirectUrl']);
            return;
          }
          if (res.fieldValues['RedirectAbsoluteUrl']) {
            this.authApiService.logoutUser(res.fieldValues['RedirectAbsoluteUrl']);
            return;
          }
          if (res.fieldValues['RedirectCommand']) {
            this.executeCommand(res.fieldValues['RedirectCommand']);
            return;
          }
          if (res.fieldValues['SnackBarMessage']) {
            const duration = res.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(res.fieldValues['SnackBarMessage'], duration);
          }
          this.invalidateSubject.invalidate();
        },
        error => {
          console.error('Failed ToolBarComponent command', error);
          this.fuseSplashScreenService.hide();
        });
    }
  }

  setSelectedTab(selectedTab: TabModel): void {
  }
  destroy() {
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private handleActions($event: GridValueChangeEvent) {
    switch ($event.action.id) {
      case 'Edit':
        this.openEditor($event);
        if ($event.fieldSection) {
          if ($event.fieldSection.id === 'expertserviceworkspace') {
            this.openWorkspaceEditor($event);
          } else if ($event.fieldSection.id === 'expertservice') {
            this.openWorkspaceServiceEditor($event);
          } else if ($event.fieldSection.id === 'expertservicetemplate') {
            this.openTemplateEditor($event);
          }
        }
        break;
      case 'OpenTemplateConversation':
        this.openActivityForTemplate($event);
        break;
      case 'OpenConversation':
        this.openActivityForService($event);
        break;
      case 'MarkAsComplete':
        this.markAsComplete($event);
        break;
      default:
        if (this.magicLinkModel.additionalCommands[$event.action.id]) {
          const command = this.magicLinkModel.additionalCommands[$event.action.id];
          command.fieldValues['ItemId'] = $event.item.id;
          this.executeCommand(command);
        }
        break;
    }
  }

  private openWorkspaceEditor(event: any) {
    const minWidth = '800px';
    const maxWidth = '800px';

    const sourceKey = this.magicLinkModel.tabBar.tabs[0].tabData['SourceType'];
    const item = Object.assign({}, event.item);
    this.dialogService.showCellEditorDialog(item, event.fieldDefinition, minWidth, maxWidth, sourceKey).subscribe(state => {
      if (state.action === 'OK') {
        const command = new PlatformCommand('UpdateWorkspaceCommand', Api.MarketPlace);
        command.fieldValues['Id'] = event.item.id;
        command.fieldValues[event.fieldDefinition.key] = event.item.cells[event.fieldDefinition.key].value;
        this.executeCommand(command);
      }
    });
  }

  private openWorkspaceServiceEditor(event: any) {
    const minWidth = '800px';
    const maxWidth = '800px';

    const sourceKey = this.magicLinkModel.tabBar.tabs[0].tabData['SourceType'];
    const item = Object.assign({}, event.item);
    this.dialogService.showCellEditorDialog(item, event.fieldDefinition, minWidth, maxWidth, sourceKey).subscribe(state => {
      if (state.action === 'OK') {
        const command = new PlatformCommand('UpdateWorkspacesServiceCommand', Api.MarketPlace);
        command.fieldValues['ServiceId'] = event.item.id;
        command.fieldValues[event.fieldDefinition.key] = event.item.cells[event.fieldDefinition.key].value;
        this.executeCommand(command);
      }
    });
  }

  private openTemplateEditor(event: any) {
    const minWidth = '800px';
    const maxWidth = '800px';

    const sourceKey = this.magicLinkModel.tabBar.tabs[0].tabData['SourceType'];
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth, sourceKey).subscribe(state => {
      if (state.action === 'OK') {
        const command = new PlatformCommand('UpdateExpertServiceTemplateCommand', Api.MarketPlace);
        command.fieldValues['Id'] = event.item.id;
        command.fieldValues[event.fieldDefinition.key] = event.item.cells[event.fieldDefinition.key].value;
        this.executeCommand(command);
      }
    });
  }

  valueChanged($event: GridValueChangeEvent) {
    console.log('[Event]', $event);
    if ($event.action) {
      this.handleActions($event);
      return;
    }
    if ($event.fieldDefinition && $event.fieldDefinition.key) {
      const command = this.magicLinkModel.additionalCommands[$event.fieldDefinition.key];
      command.fieldValues['ItemId'] = $event.item.id;
      this.executeCommandApi(command);
    }

    if ($event.fieldDefinition) {
      if ($event.fieldSection && $event.fieldSection.id === 'expertserviceworkspace') {
        switch ($event.fieldDefinition.key) {
          case 'Name':
            this.openWorkspace($event);
            break;
          default:
            break;
        }
      }
      if ($event.fieldSection && $event.fieldSection.id === 'expertservice') {
        switch ($event.fieldDefinition.key  ) {
          case 'Title':
            if ( $event.item.cells['IsFromServiceCompany'] && !$event.item.cells['IsFromServiceCompany'].value) {
              this.openWorkspaceService($event);
            }
            break;
          default:
            break;
        }
      }
    }
  }

  private openWorkspace($event: GridValueChangeEvent) {
    const command = this.magicLinkModel.additionalCommands['OpenWorkspace'];
    if (command) {
      command.fieldValues['ItemId'] = $event.item.id;
      this.executeCommand(command);
    }
  }

  private openWorkspaceService($event: GridValueChangeEvent) {
    const command = this.magicLinkModel.additionalCommands['OpenService'];
    if (command) {
      command.fieldValues['ItemId'] = $event.item.id;
      this.executeCommand(command);
    }
  }

  private openActivityForService($event: GridValueChangeEvent) {
    if ($event.item && $event.item.cells && $event.item.id) {
      const item = $event.item;
      this.platformSidebarRoutesForNavigation.removeCurrentSidebarComponentFromblackList({component: 'ActivityFeedComponent'});
      this.platformSidebarService.openActivityFeedByReferenceCode(item.id, item.cells['Title']?.displayText, true, false, true, '', 'ExpertService');
    }
  }

  private openActivityForTemplate($event: GridValueChangeEvent) {
    if ($event.item && $event.item.cells && $event.item.id) {
      const item = $event.item;
      this.platformSidebarRoutesForNavigation.removeCurrentSidebarComponentFromblackList({component: 'ActivityFeedComponent'});
      this.platformSidebarService.openActivityFeedByReferenceCode(item.id, item.cells['Title']?.displayText, true, false, false, '');
    }
  }

  private markAsComplete($event: GridValueChangeEvent) {
    this.dialogService.showYesNoDialog('Confirm Mark as Complete',
      'Are you sure you want mark as complete this service?').pipe().subscribe(state => {
      if (state && state.action === 'OK') {
        this.fuseSplashScreenService.show();
        const command = new PlatformCommand('UpdateWorkspacesServiceCommand', Api.MarketPlace);
        command.fieldValues['ServiceId'] = $event.item.id;
        command.fieldValues['Status'] = 'Completed';
        command.fieldValues['IsCompleted'] = true;
        this.commandService.executePlatformCommand(command).pipe().subscribe(response => {
          if (response.fieldValues['SnackBarMessage']) {
            this.fuseSplashScreenService.hide();
            const duration = response.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(response.fieldValues['SnackBarMessage'], duration);
            this.invalidateSubject.invalidate();
          }
          if (response.fieldValues['Error']) {
            this.snackBarService.showError(response.fieldValues['Error']);
          }
          this.fuseSplashScreenService.hide();
        }, err => {
          this.fuseSplashScreenService.hide();
          this.snackBarService.showError('Can\'t Perform Mark as Complete');
          console.log('error: ', err);
        });
      }
    });
  }

  private openEditor(event: any, type: string = '') {
    const sourceType = this.magicLinkModel.tabBar.tabs[0].tabData['SourceType'];
    const minWidth = '800px';
    const maxWidth = '1500px';
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth,
      sourceType).subscribe(state => {
      if (state.action === 'OK') {
        const value = event.item.cells[event.fieldDefinition.key]?.value;
        let command;

        if (sourceType === 'ExpertServiceFirmAdminCompanies') {
          command = this.magicLinkModel?.additionalCommands['UpdateCompany'];
          command.fieldValues['CompanyId'] = event.item.id;
        } else if (sourceType === 'ExpertServiceFirmAdminMembers'){
          command = this.magicLinkModel?.additionalCommands['UpdateMember'];
          command.fieldValues['MemberId'] = event.item.id;
        }
        command.fieldValues[event.fieldDefinition.key] = value;
        this.executeCommand(command);
      }
      if (state.action === 'OK' && event.fieldDefinition.metaData['SkipUpdate']) {
        this.invalidateSubject.invalidate();
      }
    });
  }

  private confirmationDialog(command, type: string = '', message: string = '') {
    this.dialogService.showConfirmDialog('Warning', type, 'Cancel', message, null ).subscribe(
      data => {
        if (data.action === 'OK') {
          this.executeCommandApi(command);
        }
      }
    );
  }
}
